export function substractNumbers(a, b) {
    return a - b;
}